import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { useWatch } from "react-hook-form";
import { StyledLabel } from "../../../common/components/InputLabel";

const FuturePlacementInput = ({
  control,
  register,
  specificError,
  error,
  helperText,
}) => {
  const futurePlacement = useWatch({ control, name: "futurePlacement" });

  console.log(specificError);

  return (
    <>
      <Grid item xs={3} sx={{ marginTop: 1 }}>
        <StyledLabel
          error={error}
          id="future-placement-label"
          sx={{ paddingBottom: 0 }}
        >
          Future Placement of Veneers/FPD/Dentures
        </StyledLabel>
        <FormHelperText error={error}>{helperText}</FormHelperText>
      </Grid>
      <Grid item xs={9}>
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="future-placement-label"
            name="futurePlacement"
          >
            <FormControlLabel
              value={"Yes"}
              control={<Radio {...register("futurePlacement")} />}
              label="Yes"
            />
            <FormControlLabel
              value={"No"}
              control={
                <Radio
                  {...register("futurePlacement")}
                  sx={{ marginLeft: 8 }}
                />
              }
              label="No"
            />
          </RadioGroup>
        </FormControl>
        <Box>
          {futurePlacement === "Yes" && (
            <TextField
              placeholder="Specify where"
              size="small"
              {...register("specificFuturePlacement")}
              error={Boolean(specificError)}
              helperText={specificError?.message}
            />
          )}
        </Box>
      </Grid>
    </>
  );
};

export default FuturePlacementInput;
